export default {
  NEWS_API_ENDPOINT: `https://gnews.io/api/v4`,
  NEWS_API_KEY: `1f740c7e223cf40869a99b33630091e9`,
  DATA_API_KEY: `GC3AC0RGMI23UV4P`,
  DATA_API_ENDPOINT: `https://www.alphavantage.co/query?function=GLOBAL_QUOTE`,
  GRAPH_DATA_API_ENDPOINT: `https://www.alphavantage.co/query?function=TIME_SERIES_DAILY_ADJUSTED`,
  API_ENDPOINT: `https://calm-bayou-36272.herokuapp.com/api`,
};
